import { readStamps } from './read'

export const stamps = {
  read: readStamps,
}
